<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="9">
        <v-card class="pa-4 elevation-2">
          <v-card-title class="headline mb-2">
            {{ t("message.terms.title") }}
          </v-card-title>
          <v-card-text>
            <p class="left-align">
              {{ t("message.terms.lastUpdated") }}: {{ lastUpdated }}
            </p>
            <v-divider class="mb-4"></v-divider>
            <p class="left-align">{{ t("message.terms.intro") }}</p>
            <ul class="left-align">
              <li>{{ t("message.terms.item1") }}</li>
              <li>{{ t("message.terms.item2") }}</li>
              <li>{{ t("message.terms.item3") }}</li>
              <li>{{ t("message.terms.item4") }}</li>
              <li>{{ t("message.terms.item5") }}</li>
            </ul>
            <p class="left-align contact">
              Support: <strong>{{ contactEmail }}</strong>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { inject } from "vue";

const DEFAULT_CONTACT_EMAIL = "support@onlygrades.no";

export default {
  name: "TermsPage",
  setup() {
    const state = inject("state");
    const contactEmail =
      (process.env.VUE_APP_CONTACT_EMAIL || DEFAULT_CONTACT_EMAIL).trim() ||
      DEFAULT_CONTACT_EMAIL;
    const lastUpdated = (process.env.VUE_APP_LEGAL_LAST_UPDATED || "2026-02-11")
      .trim();

    const t = (key) => {
      const keys = key.split(".");
      let value = state.translations[state.locale];
      keys.forEach((k) => {
        value = value?.[k];
      });
      return value ?? key;
    };

    return { t, contactEmail, lastUpdated };
  },
};
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
  font-size: 2rem;
  color: var(--og-text);
  font-family: "Newsreader", serif;
}

.v-card {
  background: var(--og-surface) !important;
  border: 1px solid var(--og-border);
  border-radius: 18px !important;
  box-shadow: var(--og-shadow) !important;
}

.left-align {
  text-align: left;
  line-height: 1.6;
  color: var(--og-muted);
}

.contact {
  margin-top: 14px;
}

@media (max-width: 600px) {
  .v-card-title {
    font-size: 1.5rem;
  }
}
</style>
